// The canonical encounter-room identity rule (Business Web). The exact counterpart of Android's
// `EncounterRoom.kt` and iOS's `encounterRoom.ts`.
//
// A remote consultation's media room is `enc_<appointment_id>`. A staff-to-staff call id never
// carries that prefix, which is what makes it a safe discriminator: the capture control appears for
// an encounter and is structurally unreachable for a staff call, without either surface having to
// remember to ask.
//
// The room id carries NO mode, so audio and video converge on this one rule — which is why there is
// no second video path anywhere in the capture chain, on any of the three planes.

export const ENCOUNTER_ROOM_PREFIX = 'enc_';

/**
 * The appointment this call is hosting, or null when the call is not an encounter.
 *
 * Null for a staff call, for a blank id, and for the bare prefix with nothing after it — the last of
 * which matters because `'enc_'.slice(4)` is an empty string, and an empty appointment id would
 * produce a readiness request for nothing.
 */
export function encounterAppointmentId(callId) {
  const id = (callId == null ? '' : String(callId)).trim();
  if (!id.startsWith(ENCOUNTER_ROOM_PREFIX)) return null;
  const appointmentId = id.slice(ENCOUNTER_ROOM_PREFIX.length);
  return appointmentId.length > 0 ? appointmentId : null;
}

/** Whether this call is a governed encounter consultation. */
export function isEncounterCall(callId) {
  return encounterAppointmentId(callId) !== null;
}

export default { ENCOUNTER_ROOM_PREFIX, encounterAppointmentId, isEncounterCall };
